import React from "react";
import ReportManager from "commons/components/ReportManager";
import { columns } from "commons/pages/sales/List";

const filters = [
  { type: "select", name: "facilities", key: "facility_id" },
  {
    type: "select",
    name: "users",
    key: "user_id",
    extras: { optionLabel: "username" },
  },
  { type: "select", name: "customers", key: "customer_id" },
  { type: "select", name: "policies", key: "policy_id" },
];

export default function SalesByOperation() {
  return (
    <ReportManager
      url="sales"
      title="salesByOperation"
      columns={columns}
      filterByDate
      hasChart
      filters={filters}
      totals={[
        "subtotal",
        "discount",
        "tax",
        "total",
        "commission",
        "cost",
        "profit",
      ]}
    />
  );
}
